import { svg } from './icons.js';

export const PAGES = [
  { id: 'dashboard', label: 'Painel principal', icon: 'home' },
  { id: 'empresas', label: 'Empresas', icon: 'building' },
  { id: 'documentos', label: 'Documentos', icon: 'doc' },
  { id: 'tarefas', label: 'Tarefas', icon: 'check' },
  // Escondidas a pedido da Beatriz: dependem da importação do Domínio,
  // que está fora desta versão. Basta trocar para false quando entrar.
  { id: 'balancete', label: 'Balancete', icon: 'bars', oculta: true },
  { id: 'composicao', label: 'Composição de saldos', icon: 'calc', oculta: true },
  { id: 'pesquisas', label: 'Pesquisas', icon: 'search' },
  { id: 'conhecimento', label: 'Base de conhecimento', icon: 'book' },
  { id: 'realizado', label: 'Realizado do dia', icon: 'edit' },
  { id: 'historico', label: 'Histórico', icon: 'clock' },
  // Indicadores são da gestão, a pedido dela: "a pessoa não precisa saber
  // o que está acontecendo na questão de indicadores — só se eu for
  // apresentar para ela de outro modo". O banco também recusa as funções
  // para quem não é gestão; esconder aqui é só para não oferecer uma
  // porta que vai bater na cara de quem abrir.
  { id: 'relatorios', label: 'Relatórios', icon: 'report', somenteGestao: true },
  // Abrir competências em lote, responsáveis, checklist padrão: tudo
  // decisão de gestão. O banco já recusa as operações; aqui a aba some.
  { id: 'config', label: 'Configurações', icon: 'settings', somenteGestao: true },
];

const aoEntrar = {};

/** Registra o que rodar quando a página X for aberta (ex.: recarregar histórico). */
export function aoAbrir(pageId, callback) {
  aoEntrar[pageId] = callback;
}

export function irPara(id) {
  document.querySelectorAll('.nav-item').forEach((b) =>
    b.classList.toggle('active', b.dataset.page === id)
  );
  document.querySelectorAll('.page').forEach((s) =>
    s.classList.toggle('active', s.id === 'page-' + id)
  );
  document.getElementById('sidebar').classList.remove('open');
  document.getElementById('scrim').classList.remove('show');
  aoEntrar[id]?.();
  window.scrollTo(0, 0);
}

export function montarNav({ ehGestao = false } = {}) {
  document.querySelectorAll('.nav-item').forEach((btn) => {
    const p = PAGES.find((x) => x.id === btn.dataset.page);
    if (!p) return;
    if (p.oculta || (p.somenteGestao && !ehGestao)) { btn.hidden = true; return; }
    btn.innerHTML = svg(p.icon) + `<span>${p.label}</span>`;
    btn.addEventListener('click', () => irPara(p.id));
  });

  // O separador que sobra sozinho entre grupos ocultos também sai.
  document.querySelectorAll('.nav-sep').forEach((sep) => {
    const proximos = [];
    let n = sep.nextElementSibling;
    while (n && !n.classList.contains('nav-sep')) { proximos.push(n); n = n.nextElementSibling; }
    if (proximos.length && proximos.every((x) => x.hidden)) sep.hidden = true;
  });

  const toggle = document.getElementById('menuToggle');
  toggle.innerHTML = svg('menu', 20);
  toggle.addEventListener('click', () => {
    document.getElementById('sidebar').classList.toggle('open');
    document.getElementById('scrim').classList.toggle('show');
  });
  document.getElementById('scrim').addEventListener('click', () => {
    document.getElementById('sidebar').classList.remove('open');
    document.getElementById('scrim').classList.remove('show');
  });
}
